import { IAutomationAppComponent } from "../../types";
import { schema, schemaFan, schemaPump, schemaOutput, schemaPump1, schemaPump2} from "./types";
import { OverviewPanel,OperatorPanel,ConfigurationPanel } from '.';
import { DriveIconSimple } from "../DriveBase/DriveIcon";
import { FaFan } from "react-icons/fa";
import { OperationState } from "../OperationState";
import {SideviewPanel} from "./SideviewPanel";
import InsightsPanel from "./InsightsPanel";

export const App : IAutomationAppComponent = {
    schema: schema,
    supportsProcessPanel: true,
    Icon: DriveIconSimple,
    OverviewPanel: OverviewPanel,
    OperatorPanel: OperatorPanel,
    ConfigurationPanel: ConfigurationPanel,
    SideViewPanel: SideviewPanel, 
    InsightsPanel: InsightsPanel,
    createConfig: {
        group: 'Aggregates',
        name: "Drive with 1 speed",
        description: "Drive one speed",
        panel: OverviewPanel,
        defaultState: {  isOn: true, state: OperationState.Auto }
    },
}
export const AppFan : IAutomationAppComponent = {
    schema: schemaFan,
    supportsProcessPanel: true,
    Icon: FaFan,
    OverviewPanel: OverviewPanel,
    OperatorPanel: OperatorPanel,
    ConfigurationPanel: ConfigurationPanel, 
    SideViewPanel: SideviewPanel,
    InsightsPanel: InsightsPanel, 
    createConfig: {
        group: 'Aggregates',
        name: "Fan with 1 speed",
        description: "Fan one speed",
        panel: OverviewPanel,
        defaultState: {  isOn: true, state: OperationState.Auto }
    },
}
export const AppPump : IAutomationAppComponent = {
    schema: schemaPump,
    supportsProcessPanel: true,
    Icon: DriveIconSimple,
    OverviewPanel: OverviewPanel,
    OperatorPanel: OperatorPanel,
    ConfigurationPanel: ConfigurationPanel, 
    SideViewPanel: SideviewPanel, 
    InsightsPanel: InsightsPanel,
    createConfig: {
        group: 'Aggregates',
        name: "Pump with 1 speed",
        description: "Pump one speed",
        panel: OverviewPanel,
        defaultState: {  isOn: true, state: OperationState.Auto }
    },
}
export const AppOutput : IAutomationAppComponent = {
    schema: schemaOutput,
    supportsProcessPanel: true,
    Icon: DriveIconSimple,
    OverviewPanel: OverviewPanel,
    OperatorPanel: OperatorPanel,
    ConfigurationPanel: ConfigurationPanel, 
    SideViewPanel: SideviewPanel, 
    InsightsPanel: InsightsPanel,
    createConfig: {
        group: 'Aggregates',
        name: "Output with 1 speed",
        description: "Output one speed",
        panel: OverviewPanel,
        defaultState: {  isOn: true, state: OperationState.Auto }
    },
}

export const AppPump1 : IAutomationAppComponent = {
    schema: schemaPump1,
    supportsProcessPanel: true,
    Icon: DriveIconSimple,
    OverviewPanel: OverviewPanel,
    OperatorPanel: OperatorPanel,
    ConfigurationPanel: ConfigurationPanel, 
    SideViewPanel: SideviewPanel, 
    InsightsPanel: InsightsPanel,
    createConfig: {
        group: 'Aggregates',
        name: "Primary Pump one speed (Pump switching)",
        description: "Pump primary - one speed",
        panel: OverviewPanel,
        defaultState: {  isOn: true, state: OperationState.Auto }
    },
}
export const AppPump2 : IAutomationAppComponent = {
    schema: schemaPump2,
    supportsProcessPanel: true,
    Icon: DriveIconSimple,
    OverviewPanel: OverviewPanel,
    OperatorPanel: OperatorPanel,
    ConfigurationPanel: ConfigurationPanel, 
    SideViewPanel: SideviewPanel, 
    InsightsPanel: InsightsPanel,
    createConfig: {
        group: 'Aggregates',
        name: "Secondary Pump one speed (Pump switching)",
        description: "Pump secondary - one speed",
        panel: OverviewPanel,
        defaultState: {  isOn: false, state: OperationState.Auto }
    },
}
